import { ArticleDetail, ArticleDetailType, getArticleDetails } from "./articleDetail";
import { getPostPaths, PostPaths } from "./pages";

export type { ArticleDetail, PostPaths, ArticleDetailType };
export { getArticleDetails, getPostPaths };
